<div bsModal #staticModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-static"
     [config]="{backdrop: 'static'}" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-static" class="modal-title pull-left">
                    Add Photos
                </h4>
                <button type="button" class="close pull-right" (click)="closeModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="medium-padding remove-margin">                                       
                    <!-- DevEx FileUploader -->  
                    <sp-dev-ext-file-uploader
                        [propertyId]="propertyId"
                        [value]="value"
                        [componentType]="componentType">
                    </sp-dev-ext-file-uploader>                                       
                </div>
            </div>
            
            <footer class="text-start">
                <button type="button" class="btn btn-success" (click)="closeModal()">Done</button>
            </footer>
        </div>
    </div>
</div>
